import axios from 'axios';
import { booleanParser } from './booleanParser';

export function getAppStatus() {
	let URL = `https://app-test.keepa.ir/connectionStatus/CheckConnection.json`;

	if (!booleanParser(process.env.REACT_APP_TEST_SERVER)) {
		URL = `https://service-status.keepa.ir/services_status.json`;
	}

	return axios.get(URL, {
		headers: { 'Cache-Control': 'no-cache, no-store', 'Access-Control-Allow-Origin': '*' },
	});
}
